import axios from 'axios'
import Excel from 'exceljs'
import FileSaver from 'file-saver'
import {
    START_LOADING,
    STOP_LOADING,
    SET_AVAILABLE_MEL,
    SET_MY_MEL,
    SET_PAST_MEL,
    ADD_DETAILS_MEL
} from '../reducers/types'
import {success, error} from '../components/common/toast'
import {ROOT_URL} from './config'

export function getAvailableMelee() {
    return function(dispatch) {
        dispatch({type: START_LOADING, payload: 'Retrieving Melee Inventory'})
        return axios({
            method: 'POST',
            url: `${ROOT_URL}/melee/available`
        })
        .finally(() => dispatch({type: STOP_LOADING, payload: 'Retrieving Melee Inventory'}))
        .then(res => {
            dispatch({type: SET_AVAILABLE_MEL, payload: res.data});
        })
        .catch(err => {
            error(err)
            return Promise.reject(err);
        })
    }
}

export function getCurrentMelee() {
    return function(dispatch) {
        dispatch({type: START_LOADING, payload: 'Retrieving Melee Inventory'})
        return axios({
            method: 'POST',
            url: `${ROOT_URL}/melee/customer`
        })
        .finally(() => dispatch({type: STOP_LOADING, payload: 'Retrieving Melee Inventory'}))
        .then(res => {
            dispatch({type: SET_MY_MEL, payload: res.data});
        })
        .catch(err => {
            error(err)
            return Promise.reject(err);
        })
    }
}

export function getPastMelee() {
    return function(dispatch) {
        dispatch({type: START_LOADING, payload: 'Retrieving Melee Inventory'})
        return axios({
            method: 'POST',
            url: `${ROOT_URL}/melee/past`
        })
        .finally(() => dispatch({type: STOP_LOADING, payload: 'Retrieving Melee Inventory'}))
        .then(res => {
            dispatch({type: SET_PAST_MEL, payload: res.data});
        })
        .catch(err => {
            error(err)
            return Promise.reject(err);
        })
    }
}

export function requestMelee(parcels, remarks, urgent) {
    return function(dispatch) {
        dispatch({type: START_LOADING, payload: 'Sending Request'})
        return axios({
            method: 'POST',
            url: `${ROOT_URL}/melee/request_stones`,
            data: {
                parcels: Array.isArray(parcels) ? parcels : [parcels],
                remarks: remarks ? remarks : undefined,
                urgent
            }
        })
        .finally(() => dispatch({type: STOP_LOADING, payload: 'Sending Request'}))
        .catch(err => {
            error(err);
            return Promise.reject(err);
        })
    }
}

export function returnMelee(parcels, remarks) {
    return function(dispatch) {
        dispatch({type: START_LOADING, payload: 'Signalling Return'})
        return axios({
            method: 'POST',
            url: `${ROOT_URL}/melee/return`,
            data: {
                parcels: Array.isArray(parcels) ? parcels : [parcels],
                remarks: remarks ? remarks : undefined
            }
        })
        .finally(() => dispatch({type: STOP_LOADING, payload: 'Signalling Return'}))
        .catch(err => {
            error(err);
            return Promise.reject(err);
        })
    }
}

export function sellMelee(parcels, remarks) {
    return function(dispatch) {
        dispatch({type: START_LOADING, payload: 'Making Sale'})
        return axios({
            method: 'POST',
            url: `${ROOT_URL}/melee/sale`,
            data: {
                parcels: Array.isArray(parcels) ? parcels : [parcels],
                remarks: remarks ? remarks : undefined
            }
        })
        .finally(() => dispatch({type: STOP_LOADING, payload: 'Making Sale'}))
        .catch(err => {
            error(err);
            return Promise.reject(err);
        })
    }
}

export function getMeleeDetails(parcelName) {
    return function(dispatch) {
        dispatch({type: START_LOADING, payload: 'Retrieving Melee Details'})
        return axios({
            method: 'POST',
            url: `${ROOT_URL}/melee/details`,
            data: {parcelName}
        })
        .finally(() => dispatch({type: STOP_LOADING, payload: 'Retrieving Melee Details'}))
        .then(res => {
            dispatch({type: ADD_DETAILS_MEL, payload: res.data});
        })
        .catch(err => {
            error(err);
            return Promise.reject(err);
        })
    }
}

export function deleteLastMeleeHistory(historyRow) {
    return function(dispatch) {
        dispatch({type: START_LOADING, payload: 'Cancelling History'})
        return axios({
            method: 'POST',
            url: `${ROOT_URL}/melee/undo`,
            data: {
                parcelName: historyRow.parcelName,
                action: historyRow.type
            }
        })
        .finally(() => dispatch({type: STOP_LOADING, payload: 'Cancelling History'}))
        .then(res => {
            dispatch({type: ADD_DETAILS_MEL, payload: res.data});
        })
        .catch(err => {
            error(err);
            return Promise.reject(err);
        })
    }
}

export function backdateMeleeHistory(historyRow, newDate) {
    return function(dispatch) {
        dispatch({type: START_LOADING, payload: 'Changing Date'})
        return axios({
            method: 'POST',
            url: `${ROOT_URL}/melee/change_date`,
            data: {
                parcelName: historyRow.parcelName,
                action: historyRow.type,
                newDate
            }
        })
        .finally(() => dispatch({type: STOP_LOADING, payload: 'Changing Date'}))
        /*.then(res => {
            dispatch({type: ADD_DETAILS, payload: res.data});
        })*/
        .catch(err => {
            error(err);
            return Promise.reject(err);
        })
    }
}

/*export function lgSimilarStones(params) {
    return function(dispatch) {
        dispatch({type: START_LOADING, payload: 'Checking similar diamonds'})
        return axios({
            method: 'POST',
            url: `${ROOT_URL}/labgrown/similar`,
            data: params
        })
        .finally(() => dispatch({type: STOP_LOADING, payload: 'Checking similar diamonds'}))
        .then(({data}) => data)
    }
}*/

export function excelMeleeExport(stones, extraColumns, {hideTier} = {}) {
    return function(dispatch) {
        const workbook = new Excel.Workbook();
        workbook.creator = 'Dialog';
        workbook.created = new Date();
        const sheet = workbook.addWorksheet('Dialog Melee Inventory');
        const linkFmt = {underline: true, color: {argb: 'FF0000FF'}}
        const twoDecimals = x => Number(x).toFixed(2)
        let columns = [
            {header: 'Parcel Name', key: 'parcelName', width: 19},
            {header: 'Description', key: 'skuDescription', width: 30},
            {header: 'Weight', key: 'deployedWeight', width: 8, style: {numFmt: '#,##0.00'}},
            {header: 'Quantity', key: 'deployedQuantity', width: 8},
            {header: 'Stone Weight', key: 'weightText', width: 12},
            {header: 'Shape', key: 'shapeCodes', width: 8},
            {header: 'Colour', key: 'colourText', width: 18},
            {header: 'Clarity', key: 'clarityText', width: 8},
            {header: 'PPC', key: 'ppc', width: 9, style: {numFmt: '$#,##0.00'}},
            {header: 'Price', key: 'total', width: 12, style: {numFmt: '$#,##0.00'}},
            {header: 'Status', key: 'status', width: 12},
            {header: 'V360', key: 'photoUrl', width: 12, excelCell: value => ({text: 'Image/Video', hyperlink: value})}
        ]
        if (Array.isArray(extraColumns) && extraColumns.length) {
            columns = columns.concat(extraColumns.map(col => ({
                header: col.Header,
                key: col.accessor,
                width: col.minWidth / 5,
                excelCell: col.excelCell
            })))
        }
        sheet.columns = columns;
        sheet.addRows(stones);

        for (let col of columns.filter(c => c.excelCell)) {
            const fileColumn = sheet.getColumn(col.key);
            if (!fileColumn) continue;
            fileColumn.eachCell((cell, row) => {
                if (row > 1 && cell.value) {
                    const newValue = col.excelCell(cell.value, stones[row-2]);
                    cell.value = newValue;
                    if (newValue.hyperlink) cell.font = linkFmt
                }
            })
        }

        sheet.views = [{ state: 'frozen', ySplit: 1 }]
        return workbook.xlsx.writeBuffer()
        .then(buffer => {
            FileSaver.saveAs(new Blob([buffer], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}), `Dialog Export.xlsx`);
        })
    }
}